import { useHistory } from 'react-router';
import { Spinner } from '../../components/common';
import { ROUTE_PATH } from '../../routes/paths';
import Header from '../../components/common/global-top-bar';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import RichTextEditor from '../../components/rich-text-editor/rich-text-editor';
import { Location } from 'history';
import { TextBlocksHeaderOptions } from './common/text-blocks-constants';
import SwitchBar from '../../components/switch-bar';

//@ts-ignore
import { fetchTosRequest, updateTosRequest } from './text-blocks-redux/actions';
import RouteLeavingGuard from '../../components/route-leaving-prompt';

type props = {
  pending: boolean;
  policy: any;
  aboutTos: any;
  termsOfService: any;
  footerDisclaimerText: any;
};

const MembersTOS: React.FunctionComponent<props> = ({
  pending,
  policy,
  aboutTos,
  termsOfService,
  footerDisclaimerText,
}): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [state, setstate] = useState({
    aboutUs: '',
    privacyPolicy: '',
    termsOfService: '',
    footerDisclaimerText: '',
    aboutUsSave: true,
    privacyPolicySave: true,
    termsOfServiceSave: true,
    footerDisclaimerTextSave: true,
  });

  const handleMessage = (messageType: string, data: any, fromRedux?: true) => {
    setstate({
      ...state,
      [messageType]: data,
      [messageType + 'Save']: fromRedux ? true : false,
    });
  };

  const handleSave = (messageType: string, data: any) => {
    const payload = {
      type: messageType,
      payload: {
        value: data,
      },
    };
    dispatch(updateTosRequest(payload));
  };

  useEffect(() => {
    if (aboutTos?.status === 200) {
      handleMessage('aboutUs', aboutTos?.data?.ABOUT_LOC, true);
    }
  }, [aboutTos]);

  useEffect(() => {
    if (policy?.status === 200) {
      handleMessage('privacyPolicy', policy?.data?.PRIVACY_POLICY, true);
    }
  }, [policy]);

  useEffect(() => {
    if (termsOfService?.status === 200) {
      handleMessage('termsOfService', termsOfService?.data?.TERMS_OF_SERVICE, true);
    }
  }, [termsOfService]);

  useEffect(() => {
    if (footerDisclaimerText?.status === 200) {
      handleMessage('footerDisclaimerText', footerDisclaimerText?.data?.FOOTER_DISCLAIMER_TEXT, true);
    }
  }, [footerDisclaimerText]);

  useEffect(() => {
    dispatch(fetchTosRequest({ type: 'TERMS_OF_SERVICE' }));
    dispatch(fetchTosRequest({ type: 'ABOUT_LOC' }));
    dispatch(fetchTosRequest({ type: 'PRIVACY_POLICY' }));
    dispatch(fetchTosRequest({ type: 'FOOTER_DISCLAIMER_TEXT' }));
  }, []);

  return (
    <div>
      {pending && <Spinner />}
      <RouteLeavingGuard
        when={
          !state.privacyPolicySave || !state.termsOfServiceSave || !state.aboutUsSave || !state.footerDisclaimerTextSave
        }
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: Location) => {
          if (
            !state.privacyPolicySave ||
            !state.termsOfServiceSave ||
            !state.aboutUsSave ||
            !state.footerDisclaimerTextSave
          ) {
            if (location.pathname !== ROUTE_PATH.MEMBERSTOC) {
              return true;
            }
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={'You have unsaved changes. Do you want to leave this page and lose your changes?'}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Continue and lose changes'}
      />
      <Header heading={'Members'} />
      <SwitchBar heading={TextBlocksHeaderOptions} position={0} />

      <div className="max-window-height overflow-y-auto pb-32 pt-4">
        <div>
          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">ABOUT US</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-400"
                onClick={() => {
                  handleSave('ABOUT_LOC', state.aboutUs);
                }}
                disabled={state.aboutUsSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4">
              <RichTextEditor
                content={state.aboutUs}
                onChange={(value: string) => handleMessage('aboutUs', value)}
                key={`about-us`}
                data-testid="about-us-editor"
              />
            </div>
          </div>

          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">PRIVACY POLICY</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-400"
                onClick={() => {
                  handleSave('PRIVACY_POLICY', state.privacyPolicy);
                }}
                disabled={state.privacyPolicySave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4">
              <RichTextEditor
                content={state.privacyPolicy}
                onChange={(value: string) => handleMessage('privacyPolicy', value)}
                key={`privacy-policy`}
                data-testid="privacy-policy-editor"
              />
            </div>
          </div>
          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">TERMS OF SERVICE</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-300"
                disabled={state.termsOfServiceSave}
                onClick={() => {
                  handleSave('TERMS_OF_SERVICE', state.termsOfService);
                }}
              >
                SAVE
              </button>
            </div>

            <div className="mt-4">
              <RichTextEditor
                content={state.termsOfService}
                onChange={(value: string) => handleMessage('termsOfService', value)}
                key={`terms-of-service`}
                data-testid="terms-of-service-editor"
              />
            </div>
          </div>

          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">FOOTER DISCLAIMER</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-300"
                disabled={state.footerDisclaimerTextSave}
                onClick={() => {
                  handleSave('FOOTER_DISCLAIMER_TEXT', state.footerDisclaimerText);
                }}
              >
                SAVE
              </button>
            </div>

            <div className="mt-4">
              <RichTextEditor
                content={state.footerDisclaimerText}
                onChange={(value: string) => handleMessage('footerDisclaimerText', value)}
                key={`footer-disclaimer-text`}
                data-testid="footer-disclaimer-text-editor"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pending: state.Tos?.pending || null,
    policy: state.Tos.Policy || null,
    aboutTos: state.Tos.aboutTos || null,
    termsOfService: state.Tos.termsOfService || null,
    footerDisclaimerText: state.Tos.footerDisclaimerText || null,
  };
};

export default connect(mapStateToProps)(MembersTOS);
